import { type FC, Suspense } from 'react';
import { usePreloadedQuery, type PreloadedQuery } from 'react-relay';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';

import { SellerReviewsModalContent } from './SellerReviewsModalContent/SellerReviewsModalContent';
import { SellerReviewsMobileModalContent } from './SellerReviewsModalContent/SellerReviewsMobileModalContent';
import { Query } from './SellerReviewsModalQuery';

import { type SellerReviewsModalQuery } from './__generated__/SellerReviewsModalQuery.graphql';

const SellerReviewsModal: FC<{
    onClose: () => void;
    contentOnly: boolean;
    isOpen: boolean;
    sellerId: string;
    isMobileScrollContainer: boolean;
    queryReference: PreloadedQuery<SellerReviewsModalQuery>;
    noTabs?: boolean;
}> = ({
    isOpen,
    contentOnly = false,
    onClose,
    sellerId,
    isMobileScrollContainer,
    queryReference,
    noTabs,
}) => {
    const { viewer } = usePreloadedQuery<SellerReviewsModalQuery>(Query, queryReference);

    const ReviewModalContent = isMobileScrollContainer
        ? SellerReviewsMobileModalContent
        : SellerReviewsModalContent;

    if (contentOnly) {
        return (
            <ReviewModalContent viewer={viewer} sellerId={sellerId} contentOnly noTabs={noTabs} />
        );
    }

    return (
        <ModalContainer isOpen={isOpen} onClose={onClose} modalSize="medium">
            <ModalCloseButton onClick={onClose} />

            <Suspense fallback={<ReviewModalContent viewer={null} sellerId={sellerId} isLoading />}>
                <ReviewModalContent viewer={viewer} sellerId={sellerId} noTabs={noTabs} />
            </Suspense>
        </ModalContainer>
    );
};

export default SellerReviewsModal;
